import { useEffect, useState } from "react";
import { UploadDataModal } from "../modal";
import { useAppSelector, useStateWithSearchParams } from "../../../hooks";
import { selectPermissions } from "../../../features/permissionsSlice";
import { ReuseButton } from "../ReuseButton";
import { ButtonsColorType, ButtonsType } from "../../../types/enums";

export const UploadDataBtn = ({ campaign_id }: { campaign_id: string }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { isAllowedEditResyncData } = useAppSelector(selectPermissions);

  const { searchDict } = useStateWithSearchParams<{
    crm?: string;
    actionType?: string;
  }>({
    crm: undefined,
    actionType: undefined,
  });

  useEffect(() => {
    if (searchDict.crm && searchDict.actionType === "upload") {
      setIsOpen(true);
    }
  }, [searchDict]);

  return (
    <>
      <ReuseButton
        buttonType={ButtonsType.contained}
        buttonColor={ButtonsColorType.gradient}
        disabled={!isAllowedEditResyncData}
        onClick={() => setIsOpen(true)}
      >
        Upload Data
      </ReuseButton>

      {isOpen && (
        <UploadDataModal
          campaign_id={campaign_id}
          hasFileImports={false}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
        />
      )}
    </>
  );
};
